import { StackProps } from '@mui/material'

import { StyledStackRow } from '@/components/uiParts/legacy/Stack/Row/style'

export const StackRow = ({ children, ...rest }: StackProps) => (
  <StyledStackRow {...rest}>{children}</StyledStackRow>
)
